import { useState, useEffect } from 'react'

interface NetworkState {
  online: boolean | undefined
}

export function useNetworkState(): NetworkState {
  const [online, setOnline] = useState<boolean | undefined>(
    typeof navigator !== 'undefined' ? navigator.onLine : undefined,
  )

  useEffect(() => {
    const goOnline = () => setOnline(true)
    const goOffline = () => setOnline(false)
    window.addEventListener('online', goOnline)
    window.addEventListener('offline', goOffline)
    return () => {
      window.removeEventListener('online', goOnline)
      window.removeEventListener('offline', goOffline)
    }
  }, [])

  return { online }
}
